'use strict';

var scrollToFirstError = require('./scrollToFormError');

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
	var valid = true;
	if (this.checkValidity && !this.checkValidity()) {
		// safari
		valid = false;
		if (event) {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		}
		var formEl = this;
		$(formEl).find('input, select, textarea').each(function () {
			applyConstraintValidationUI(this);
		});
		window.requestAnimationFrame(function () {
			scrollToFirstError(formEl);
		});
	}
	return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
	$(form).find('.form-control.is-invalid').removeClass('is-invalid');
	$(form).find('.invalid-feedback').empty();
}

function applyConstraintValidationUI(input) {
	var validationMessage;
	var $input;
	var $form;

	if (!input || !input.validity || input.validity.valid) {
		return;
	}

	validationMessage = input.validationMessage;
	$input = $(input);
	$form = $input.closest('form');

	input.setCustomValidity('');
	$input.addClass('is-invalid');

	if (input.validity.patternMismatch && $input.data('pattern-mismatch')) {
		validationMessage = $input.data('pattern-mismatch');
	}
	if ((input.validity.rangeOverflow || input.validity.rangeUnderflow)
		&& $input.data('range-error')) {
		validationMessage = $input.data('range-error');
	}
	if ((input.validity.tooLong || input.validity.tooShort)
		&& $input.data('range-error')) {
		validationMessage = $input.data('range-error');
	}
	if (input.validity.valueMissing && $input.data('missing-error')) {
		validationMessage = $input.data('missing-error');
	}

	$input.closest('.form-group').find('.invalid-feedback').first().text(validationMessage);

	if (!$form.hasClass('subscription-address-drawer-form') && !$form.data('lvz-scroll-to-error')) {
		$form.data('lvz-scroll-to-error', true);
		window.requestAnimationFrame(function () {
			scrollToFirstError($form);
			$form.removeData('lvz-scroll-to-error');
		});
	}
}

module.exports = {
	invalid: function () {
		document.addEventListener('invalid', function (e) {
			e.preventDefault();
			applyConstraintValidationUI(e.target);
		}, true);
	},

	submit: function () {
		$('form').on('submit', function (e) {
			if ($(this).is('.subscription-address-drawer-form, [data-custom-validation]')) {
				return true;
			}

			return validateForm.call(this, e);
		});
	},

	buttonClick: function () {
		$('form button[type="submit"], form input[type="submit"]').on('click', function () {
			// clear all errors when trying to submit the form
			clearForm($(this).parents('form'));
		});
	},

	functions: {
		validateForm: function (form, event) {
			validateForm.call($(form), event || null);
		},
		clearForm: clearForm
	}
};
